module.exports = __webpack_public_path__ + "img/image1.894dd829.png";